import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-menu',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class UmssMenuComponent {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() label?: string;
  @Input() ariaLabel?: string;

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() variant: 'Default' | 'Compact' = 'Default';
  @Input() spacing: 'None' | 'Tight' | 'Regular' | 'Loose' = 'Regular';

  /** State props */
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;

  /** Event outputs */
  @Output() menuOpen = new EventEmitter<void>();
  @Output() menuClose = new EventEmitter<void>();

  /** Internal state */
  private _isOpen: boolean = false;

  get isOpen(): boolean {
    return this._isOpen;
  }

  /** Event handlers */
  onMenuToggle(): void {
    if (this.disabled || this.loading) return;

    this._isOpen = !this._isOpen;
    if (this._isOpen) {
      this.menuOpen.emit();
    } else {
      this.menuClose.emit();
    }
  }

  onClickOutside(): void {
    if (this._isOpen) {
      this._isOpen = false;
      this.menuClose.emit();
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.disabled || this.loading) return;

    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.onMenuToggle();
        break;
      case 'Escape':
        if (this._isOpen) {
          this._isOpen = false;
          this.menuClose.emit();
        }
        break;
    }
  }
}
